module.exports = __webpack_public_path__ + "img/fb-dist.f6a53c8d.svg";